import { render, staticRenderFns } from "./RegistrationFormListPage.vue?vue&type=template&id=3556a864&scoped=true&"
import script from "./RegistrationFormListPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormListPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormListPage.vue?vue&type=style&index=0&id=3556a864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556a864",
  null
  
)

export default component.exports